import { ROLES } from '@/constants/roles';

export const uiPersonal = {
  path: '/personal-menu',
  name: 'ui-personal',
  component: () => import('./views/personal-main.vue'),
  meta: {
    layout: 'ui-design',
    icon: '$ui-plus',
    title: 'Персонал',
    accessList: [ROLES.organization, ROLES.event_manager],
  },
};

export default [
  uiPersonal,
  // {
  //   path: '/personal/experts',
  //   name: 'ui-personal-experts',
  //   component: () => import('@/modules/UIDesign/Events/views/event-create/event-create.vue'),
  //   meta: {
  //     layout: 'ui-design',
  //     title: 'Эксперты',
  //     back: true,
  //     accessList: [ROLES.organization, ROLES.event_manager],
  //   },
  // },
  {
    path: '/personal/event-managers',
    name: 'ui-personal-managers',
    component: () => import('./views/personal-event-managers.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Event-менеджеры',
      back: true,
      accessList: [ROLES.organization, ROLES.event_manager],
    },
  },
];
